import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, mergeProps as _mergeProps, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f05b66f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "record_box" }
const _hoisted_2 = { class: "record_head flex" }
const _hoisted_3 = { class: "head_left flex" }
const _hoisted_4 = {
  key: 0,
  class: "video_time"
}
const _hoisted_5 = {
  key: 1,
  class: "video_time"
}
const _hoisted_6 = { class: "video_circle flex" }
const _hoisted_7 = { class: "head_right flex" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://images.innocomn.com/21216202405060942574633.svg",
  class: "but_icon"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "开始直播", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "结束直播", -1))
const _hoisted_11 = { class: "list_box" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "list_num" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://images.innocomn.com/06769202405060934419211.svg",
  class: "icon"
}, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "left_cover flex" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "left_time" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "right_text flex" }
const _hoisted_22 = { class: "text_title" }
const _hoisted_23 = {
  class: "mover",
  src: "https://images.innocomn.com/f663f202405061040508669.svg",
  alt: "",
  srcset: ""
}
const _hoisted_24 = {
  key: 1,
  class: "video_empty",
  src: "https://images.innocomn.com/7c193202405101519455116.svg",
  alt: "",
  srcset: ""
}
const _hoisted_25 = { class: "modal_box" }
const _hoisted_26 = { class: "modal_head flex" }
const _hoisted_27 = { class: "video_num" }
const _hoisted_28 = { class: "flex modal_btn" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "search_icon",
  src: "https://images.innocomn.com/ce7fc202405080952294593.svg",
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_30 = { class: "modal_list" }
const _hoisted_31 = {
  key: 0,
  class: "list_scroll"
}
const _hoisted_32 = ["onClick"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list_current" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://images.innocomn.com/c040d202405060946031944.svg",
    alt: "",
    srcset: ""
  })
], -1))
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://images.innocomn.com/06769202405060934419211.svg",
  class: "icon"
}, null, -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "left_cover flex" }
const _hoisted_38 = ["src"]
const _hoisted_39 = { class: "left_time" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "right_text flex" }
const _hoisted_42 = { class: "text_titles" }
const _hoisted_43 = { class: "text_createtime" }
const _hoisted_44 = {
  key: 1,
  class: "video_empty",
  src: "https://images.innocomn.com/7c193202405101519455116.svg",
  alt: "",
  srcset: ""
}
const _hoisted_45 = { class: "pagination_box" }
const _hoisted_46 = { class: "modal_tip" }
const _hoisted_47 = {
  key: 0,
  style: {"display":"flex","justify-content":"space-around","position":"relative"}
}

import { createVNode, onMounted, reactive, ref, computed, onBeforeUnmount } from 'vue';
import { ExclamationCircleFilled } from '@ant-design/icons-vue';
import { Modal, Pagination, Input, message } from 'ant-design-vue';
import { VueDraggableNext } from 'vue-draggable-next';
import { dragDrop } from '@/utils/format/dragDrop';
import http from '@/api';
import { useRoute } from 'vue-router';
import { useConsoleStore } from '@/pinia/console';
import 'video.js/dist/video-js.css';
import Cookies from 'js-cookie';
import EventBus from '@/components/EventBus';
interface pageItem {
  current: number;
  pageSize: number;
  totalSize: number;
  options?: [] | any;
}
interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: string;
  url?: string;
  type?: string;
}

interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}
// 拖拽

export default /*#__PURE__*/_defineComponent({
  __name: 'recordBroad',
  setup(__props, { expose }) {

const aModal = Modal;
const aPagination = Pagination;
const aInputSearch = Input.Search;
const draggable = VueDraggableNext;

const route = useRoute();
const consoleStore = useConsoleStore();
const videoListToken = Cookies.get('video_list_token');
const iframeUrl = process.env.VUE_APP_LIVE_API + '?token=' + videoListToken;
const videoRef = ref();
const recordState = ref();
const recordTime = ref();
const inputValue = ref('');
const videoUploadList = ref();
const fileStatus = ref();
const videoPlayer = ref();
const videoUrl = ref();
const checked = ref(false);
const showBtn = ref(false);
const addVisible = ref(false);
const videoVisible = ref(false);
const playStatus = ref(false);
const menuKey = ref(null);
const isUploadingMessageShown = ref(false);
const videoPath = ref<any>([]);
const addVideoList = ref<any>([]);
const videoList = ref<any>([]);
const checkAll = ref(false);
const keys = ref({});
const checkNum = ref(0);
const iframeDom = ref<any>();
const showReocrd = ref(false);

const hours = ref(0);
const minutes = ref(0);
const seconds = ref(0);
let timerId: ReturnType<typeof setInterval> | null = null;
const isTimerRunning = ref(false);

// 格式化时间
let timeFormatted: any = computed(() => {
  const pad = (n: number) => (n < 10 ? '0' + n : n);
  return `${pad(hours.value)}:${pad(minutes.value)}:${pad(seconds.value)}`;
});
// 启动计时器
const startTimer = () => {
  if (isTimerRunning.value) return;
  isTimerRunning.value = true;
  timerId = setInterval(() => {
    seconds.value = (seconds.value + 1) % 60;
    if (seconds.value === 0) {
      minutes.value = (minutes.value + 1) % 60;
      if (minutes.value === 0) {
        hours.value = (hours.value + 1) % 24; // 假设我们只需要24小时制
      }
    }
  }, 1000);
};
// 暂停倒计时
const stopTimer = () => {
  if (!isTimerRunning.value) return;
  clearInterval(timerId!);
  timerId = null;
  isTimerRunning.value = false;
  hours.value = 0;
  minutes.value = 0;
  seconds.value = 0;
};
onBeforeUnmount(() => {
  // 确保在组件卸载前清除计时器
  if (timerId) {
    clearInterval(timerId);
    timerId = null;
  }
});

// 分页器
const pageConfig = reactive<pageItem>({
  current: 1, // 当前页
  pageSize: 10, // 每页条数
  totalSize: 0, // 总数
  options: ['10', '20', '30', '40', '50'], // 选项
});
const dragOptions = {
  animation: 0,
  group: 'description',
  disabled: false,
  ghostClass: 'ghost',
};
const listClick = (item: any) => {
  menuKey.value = item.id;
};
// 实现多选
const addVideoClick = (item: any) => {
  if (checkAll.value !== true) {
    const indexs = videoPath.value.indexOf(item.path);
    if (indexs >= 0) {
      videoPath.value.splice(indexs, 1);
      item.select = false;
    } else {
      videoPath.value.push(item.path);
      item.select = true;
    }
  } else {
    keys.value[item.id] = !keys.value[item.id];
    changeCheckNum();
  }
};
const addClick = () => {
  addVisible.value = true;
  getAddVideoList();
};
// 添加视频列表
const getAddVideoList = () => {
  let data = {
    page: pageConfig.current,
    page_num: pageConfig.pageSize,
    keywords: inputValue.value,
  };
  http.recordBroad
    .getList({ params: data })
    .then((res: any) => {
      addVideoList.value = [];
      keys.value = {};
      addVideoList.value = res.data.data.data;
      pageConfig.current = res.data.data.page;
      pageConfig.totalSize = res.data.data.count;
      addVideoList.value.forEach((i: any) => {
        keys.value[i.id] = false;
      });
    })
    .catch((err: any) => {
      // message.warn(err?.data.message);
    });
};
// 结束拖拽
const toEndDrag = () => {
  videoPath.value = [];
  handleOk();
};
const cancelClick = () => {
  pageConfig.current = 1;
  videoPath.value = [];
  checkNum.value = 0;
  checkAll.value = false;
};
// 确定添加视频点击事件
const handleOk = () => {
  return new Promise((resolve, reject) => {
    const path = videoList.value.map((item: any) => item.path);
    const addPath = path.concat(videoPath.value);
    let params = {
      studio_id: route.params.studioId,
      path: addPath,
    };
    http.recordBroad
      .listSetting(params)
      .then((res) => {
        addVisible.value = false;
        pageConfig.current = 1;
        getVideoList();
        resolve(res);
        videoPath.value = [];
      })
      .catch((err) => {
        message.warn(err.data.message);
        reject(err);
      });
  });
};
//开始直播
const startClick = () => {
  Modal.confirm({
    centered: true,
    icon: createVNode(ExclamationCircleFilled),
    content: '确定要开始列表直播吗?',
    okText: () => '确定',
    cancelText: () => '取消',
    onOk() {
      return new Promise((resolve, reject) => {
        let params = {
          studio_id: route.params.studioId,
          path: consoleStore.consoleInfo.pushUrl,
        };
        http.recordBroad
          .pushSetting(params)
          .then((res) => {
            let data = {
              studio_id: route.params.studioId,
            };
            http.recordBroad
              .startLive(data)
              .then((res) => {
                showBtn.value = true;
                startTimer();
                resolve(res);
              })
              .catch((err) => {
                message.warn(err.data.message);
                reject(err);
              });
            resolve(res);
          })
          .catch((err) => {
            message.warn(err.data.message);
            reject(err);
          });
      });
    },
  });
};
EventBus.on('liveStatus', (val: any) => {
  if (val.status == 2) {
    showBtn.value = false;
    stopTimer();
  }
});
// 结束直播
const endtClick = () => {
  Modal.confirm({
    centered: true,
    icon: createVNode(ExclamationCircleFilled),
    content: '确定要结束列表直播吗?',
    okText: () => '确定',
    cancelText: () => '取消',
    onOk() {
      return new Promise((resolve, reject) => {
        let params = {
          studio_id: route.params.studioId,
        };
        http.recordBroad
          .endLive(params)
          .then((res) => {
            showBtn.value = false;
            stopTimer();
            resolve(res);
          })
          .catch((err) => {
            message.warn(err.data.message);
            reject(err);
          });
      });
    },
  });
};
// 循环播放
const checkInfo = (e: any) => {
  let params = {
    studio_id: route.params.studioId,
    play_model: e.target.checked == true ? 'loop' : 'list',
  };
  http.recordBroad
    .modeLive(params)
    .then((res) => {
      console.log(res);
    })
    .catch((err) => {
      message.warn(err.data.message);
    });
};
// 列表
const getVideoList = () => {
  let params = {
    studio_id: route.params.studioId,
  };
  http.recordBroad
    .getListUse({
      params,
    })
    .then((res: any) => {
      videoList.value = res.data.data;
    })
    .catch((err: any) => {
      message.error(err.data.error);
    });
};
getVideoList();
// 删除视频 
const delClick = (index: number) => {
  Modal.confirm({
    centered: true,
    icon: createVNode(ExclamationCircleFilled),
    content: '此操作将删除该文件，是否继续？',
    okText: () => '确定',
    cancelText: () => '取消',
    onOk() {
      if (index >= 0 && index < videoList.value.length) {
        videoList.value.splice(index, 1);
        videoPath.value = [];
        handleOk();
      }
    },
  });
};
// 删除添加视频中的视频
const delVideoClick = (item: any, index: number) => {
  Modal.confirm({
    centered: true,
    icon: createVNode(ExclamationCircleFilled),
    content: '此操作将删除该文件，是否继续？',
    okText: () => '确定',
    cancelText: () => '取消',
    onOk() {
      http.recordBroad
        .delListLiveVideo({
          id: item.id,
        })
        .then((res: any) => {
          if (res.data.code == 200) {
            videoPath.value = [];
            getAddVideoList();
          } else {
            message.error(res.data.error);
          }
        })
        .catch((err: any) => {
          message.error(err.data.error);
        });
    },
  });
};
// 全选
const onCheckAllChange = () => {
  if (checkAll.value === true) {
    Object.keys(keys.value).forEach((k) => {
      keys.value[k] = true;
    });
  } else {
    Object.keys(keys.value).forEach((k) => {
      keys.value[k] = false;
    });
  }
  changeCheckNum();
};

// 全选删除
const deleteLive = () => {
  Modal.confirm({
    centered: true,
    icon: createVNode(ExclamationCircleFilled),
    content: '此操作将删除该文件，是否继续？',
    okText: () => '确定',
    cancelText: () => '取消',
    onOk() {
      let arr: string[] = [];
      Object.keys(keys.value).forEach((k, j) => {
        keys.value[k] == true ? arr.push(Object.keys(keys.value)[j]) : '';
      });
      http.recordBroad
        .delListLiveVideo({
          id: arr.join(','),
        })
        .then((res) => {
          if (res.data.code == 200) {
            getAddVideoList();
            // 清空id
            let del: any = [];
            addVideoList.value.map((res: any) => {
              del.push(res.id);
            });
          } else {
            message.error(res.data.error);
          }
        })
        .catch((res) => {
          message.error(res.data.error);
        });
      checkAll.value = false;
    },
  });
};
// 单选高亮删除
const isSelected = computed(() => {
  return !Object.keys(keys.value).some((e) => keys.value[e] === true);
});

const changeCheckNum = () => {
  let arr: string[] = [];
  Object.keys(keys.value).forEach((k, j) => {
    keys.value[k] == true ? arr.push(Object.keys(keys.value)[j]) : '';
  });
  if (arr.length <= 0) {
    checkAll.value = false;
  }
  checkNum.value = arr.length;
};
// 详情
const getStartAt = async () => {
  try {
    let params = {
      studio_id: route.params.studioId,
    };
    http.recordBroad
      .startAt({
        params: params,
      })
      .then((res: any) => {
        recordState.value = res.data.data.mode;
        recordTime.value = res.data.data.time;
        if (recordTime.value === -1) {
          showBtn.value = false;
        } else {
          showBtn.value = true;
          const [apiHours, apiMinutes, apiSeconds] = recordTime.value.split(':').map(Number);
          hours.value = apiHours;
          minutes.value = apiMinutes;
          seconds.value = apiSeconds;
          startTimer();
        }
        if (recordState.value === 'list') {
          checked.value = false;
        } else {
          checked.value = true;
        }
      })
      .catch((err: any) => {
        message.error(err.data.error);
      });
  } catch (error) {
    console.log(error);
  }
};
onMounted(() => {
  getStartAt();
});
// 上传视频
const uploadVideo = (info: FileInfo) => {
  fileStatus.value = info.file.status;
  videoUploadList.value = info.file;
  if (fileStatus.value == 'uploading') {
    if (!isUploadingMessageShown.value) {
      message.loading('上传中请勿刷新页面', 2.5).then(
        () => message.success('上传完成', 1),
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        () => {}
      );
      isUploadingMessageShown.value = true;
    }
  }
  if (fileStatus.value == 'done') {
    getAddVideoList();
    isUploadingMessageShown.value = false;
  }
};
const modalCancel = () => {
  playStatus.value = false;
  videoPlayer.value.dispose();
  videoVisible.value = false;
};
const videoPlay = (item: any) => {
  playStatus.value = true;
  videoUrl.value = item.path;
  videoVisible.value = true;
  setTimeout(() => {
    Mplayer(item.path); // 2d
  });
};
const Mplayer = (url: any) => {
  videoPlayer.value = new window.videojs(videoRef.value, {
    // poster: poster,//海报 
    playbackRates: [0.5, 0.75, 1, 1.5, 2], //播放速度
    language: 'zh-CN',
    notSupportedMessage: '此视频暂时无法播放,请稍后再试',
    controls: true,
    techOrder: ['html5'], //html5模式
    fluid: true, //流式布局,适应父元素大小
    aspectRatio: '16:9', //流式布局时，自适应大小的比例
    preload: true, //预加载
    autoplay: true, //是否自动播放 
    loop: true,
  });
  videoPlayer.value.src({
    src: url,
  });
};

// 监听iframe里的方法
window.addEventListener('message', (event) => {
  if (event.data.cmd === 'jump') {
    getAddVideoList();
    message.success('上传完成', 1);
  }
});

// 直播记录 
const useRecord = () => {
  showReocrd.value = true;
}
const recodCancel = () => {
  showReocrd.value = false;
}
expose({
  getAddVideoList,
});

return (_ctx: any,_cache: any) => {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_unref(timeFormatted))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, "已直播时长: " + _toDisplayString(_unref(timeFormatted)), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, "已直播时长: 00:00:00")),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_a_checkbox, {
            checked: checked.value,
            "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((checked).value = $event)),
            disabled: videoList.value.length == 0,
            onChange: checkInfo
          }, {
            default: _withCtx(() => [
              _createTextVNode("列表循环播放")
            ]),
            _: 1
          }, 8, ["checked", "disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: "video_add flex",
          onClick: addClick
        }, [
          _hoisted_8,
          _createTextVNode("添加视频 ")
        ]),
        (!showBtn.value)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              type: "primary",
              class: "container_but mar_left",
              onClick: startClick,
              disabled: videoList.value.length == 0
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["disabled"]))
          : (_openBlock(), _createBlock(_component_a_button, {
              key: 1,
              type: "primary",
              danger: "",
              class: "container_but mar_left",
              onClick: endtClick
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }))
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      (videoList.value.length !== 0)
        ? (_openBlock(), _createBlock(_unref(draggable), _mergeProps({
            key: 0,
            handle: ".mover",
            class: "list_scroll",
            list: videoList.value
          }, dragOptions, {
            disabled: videoList.value.length < 1,
            onDrop: _unref(dragDrop),
            onEnd: _cache[1] || (_cache[1] = ($event: any) => (toEndDrag()))
          }), {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(videoList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "list_content flex",
                  key: index,
                  onClick: ($event: any) => (listClick(item))
                }, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(index + 1), 1),
                  _createElementVNode("div", {
                    class: "list_del",
                    onClick: ($event: any) => (delClick(index))
                  }, _hoisted_16, 8, _hoisted_14),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("img", {
                      src: item.kv,
                      alt: "",
                      srcset: ""
                    }, null, 8, _hoisted_18),
                    _createElementVNode("div", _hoisted_19, _toDisplayString(item.time), 1),
                    _createElementVNode("img", {
                      class: "start_play",
                      onClick: ($event: any) => (videoPlay(item)),
                      src: "https://images.innocomn.com/2be00202405081039128486.svg",
                      alt: "",
                      srcset: ""
                    }, null, 8, _hoisted_20)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, _toDisplayString(item.title), 1)
                  ]),
                  _withDirectives(_createElementVNode("img", _hoisted_23, null, 512), [
                    [_vShow, videoList.value.length > 1]
                  ])
                ], 8, _hoisted_12))
              }), 128))
            ]),
            _: 1
          }, 16, ["list", "disabled", "onDrop"]))
        : (_openBlock(), _createElementBlock("img", _hoisted_24))
    ]),
    _createVNode(_unref(aModal), {
      visible: addVisible.value,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((addVisible).value = $event)),
      title: "添加视频",
      centered: "",
      width: 900,
      onOk: handleOk,
      onCancel: cancelClick
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, "已选视频（" + _toDisplayString(videoPath.value.length ? videoPath.value.length : checkNum.value) + "）", 1),
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_a_checkbox, {
                class: "check_all",
                disabled: addVideoList.value.length == 0,
                checked: checkAll.value,
                "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((checkAll).value = $event)),
                onChange: onCheckAllChange
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 全选 ")
                ]),
                _: 1
              }, 8, ["disabled", "checked"]),
              _createVNode(_component_a_button, {
                type: "link",
                danger: "",
                disabled: _unref(isSelected),
                onClick: deleteLive
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_svg_icon, {
                    class: "mod_btn_icon",
                    "icon-class": "del"
                  })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" 删除 ")
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_unref(aInputSearch), {
                class: "mod_range_picker_search right",
                value: inputValue.value,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((inputValue).value = $event)),
                placeholder: "请输入搜索内容",
                onSearch: getAddVideoList
              }, {
                enterButton: _withCtx(() => [
                  _hoisted_29
                ]),
                _: 1
              }, 8, ["value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            (addVideoList.value.length !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addVideoList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["list_content flex", [item.select ? 'addactived' : '', keys.value[item.id] ? 'delactived' : '']]),
                      key: item.id,
                      onClick: ($event: any) => (addVideoClick(item))
                    }, [
                      _hoisted_33,
                      _createElementVNode("div", {
                        class: _normalizeClass(["list_del", (checkAll.value && keys.value[item.id]) || item.select ? 'displayDel' : '']),
                        onClick: _withModifiers(($event: any) => (delVideoClick(item, index)), ["stop"])
                      }, _hoisted_36, 10, _hoisted_34),
                      _createElementVNode("div", _hoisted_37, [
                        (item.kv)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: item.kv,
                              alt: "",
                              srcset: ""
                            }, null, 8, _hoisted_38))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_39, _toDisplayString(item.time), 1),
                        _createElementVNode("img", {
                          class: "start_play",
                          onClick: ($event: any) => (videoPlay(item)),
                          src: "https://images.innocomn.com/2be00202405081039128486.svg",
                          alt: "",
                          srcset: ""
                        }, null, 8, _hoisted_40)
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, _toDisplayString(item.title), 1),
                        _createElementVNode("div", _hoisted_43, "创建时间：" + _toDisplayString(item.create_time), 1)
                      ])
                    ], 10, _hoisted_32))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("img", _hoisted_44))
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createVNode(_unref(aPagination), {
              "show-quick-jumper": "",
              total: pageConfig.totalSize,
              current: pageConfig.current,
              "onUpdate:current": _cache[4] || (_cache[4] = ($event: any) => ((pageConfig.current) = $event)),
              "page-size": pageConfig.pageSize,
              "onUpdate:pageSize": _cache[5] || (_cache[5] = ($event: any) => ((pageConfig.pageSize) = $event)),
              pageSizeOptions: pageConfig.options,
              "show-less-items": "",
              "show-size-changer": "",
              onChange: getAddVideoList,
              onShowSizeChange: getAddVideoList
            }, {
              buildOptionText: _withCtx((props) => [
                _createElementVNode("span", null, _toDisplayString(props.value) + "条/页", 1)
              ]),
              _: 1
            }, 8, ["total", "current", "page-size", "pageSizeOptions"])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("iframe", {
              style: {"border":"none"},
              src: iframeUrl,
              width: "100%",
              height: "40px",
              ref_key: "iframeDom",
              ref: iframeDom
            }, null, 512)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(aModal), {
      visible: videoVisible.value,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((videoVisible).value = $event)),
      centered: "",
      footer: null,
      zIndex: 2000,
      width: "65%",
      onCancel: modalCancel,
      closable: false
    }, {
      default: _withCtx(() => [
        (playStatus.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
              _createElementVNode("video", {
                ref_key: "videoRef",
                ref: videoRef,
                id: "videojs-player",
                controls: "",
                class: "video-js vjs-matrix vjs-default-skin vjs-big-play-centered"
              }, null, 512),
              _createElementVNode("div", {
                style: {"position":"absolute","top":"-20px","right":"-14px","cursor":"pointer"},
                onClick: modalCancel
              }, "✖")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(aModal), {
      visible: showReocrd.value,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((showReocrd).value = $event)),
      centered: "",
      footer: null,
      zIndex: 2000,
      width: "65%",
      onCancel: recodCancel,
      closable: false
    }, null, 8, ["visible"])
  ]))
}
}

})